<template>
  <div class="front-layout">
    <nav class="navbar" :class="{ 'scrolled': isScrolled }">
      <div class="navbar-container">
        <a class="navbar-brand" href="#home">
          <img src="@/static/v2/img/logo2.png" alt="logo" class="logo" />
        </a>

        <button class="navbar-toggler" @click="toggleNav" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
          <span class="menu-text">菜单</span>
        </button>

        <ul class="navbar-nav" id="navbarLinks" :class="{ 'show': navOpen }">
          <li class="active"><a href="javascript:void(0);" data-target="home">首页</a></li>
          <li><a href="javascript:void(0);" data-target="products">产品功能</a></li>
          <li><a href="javascript:void(0);" data-target="features">核心特性</a></li>
          <li><a href="javascript:void(0);" data-target="news">使用教程</a></li>
          <li><a href="javascript:void(0);" data-target="money">关于价格</a></li>
          <li><router-link to="/jsdaixie">脚本定制</router-link></li>
          <li><router-link to="/resource-download">资源下载</router-link></li>
          <li>
            <a href="http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=h7_fZQsaizIfydS9FIAh0kXSk77cJVhh&authKey=7Nod8xG8Uv%2FgSOjZKWXTGcQ8UAN%2FdrWlbViyLqb08GxewhRfU3paOp7sMriXmTBa&noverify=0&group_code=277037273"
              target="_blank">QQ群</a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Hero Section -->
    <div class="hero" id="home">
      <div class="hero-container">
        <div class="hero-content">
          <h1 class="hero-title">键鼠自动化 — 为您解放双手</h1>
          <p class="hero-subtitle">
            最好用、全自动化、自动游戏、自动办公...<br />无需双手,自动完成！
          </p>
          <el-button type="primary" @click="goToResourceDownload" class="download-btn">
            立即下载
          </el-button>
        </div>

        <div class="hero-animation swiper-container" id="gifId" @click="handleSwiperClick">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(image, index) in heroImages" :key="index">
              <img :src="image" alt="产品展示" class="swiper-image" :data-src="image" />
            </div>
          </div>
        </div>

        <!-- 添加图片放大查看层 -->
        <div v-show="showEnlargedImage" class="image-enlarger" @click="closeEnlargedImage">
          <div class="image-enlarger-content" @click.stop>
            <button class="image-enlarger-close" @click="closeEnlargedImage">×</button>
            <img :src="currentEnlargedImage" alt="放大查看" />
          </div>
        </div>

        <div id="shipin" v-show="shipinVisible"
          style="position: fixed; left: 50%; top: 20%; z-index: 9999; transform: translateX(-50%);">
          <div
            style="width: 40px; border: 1px solid rgba(0, 0, 0, 0.2); color: #000; position: absolute; top: 18px; right: 0; text-align: center; cursor: pointer;"
            @click="shipinClose">
            关闭
          </div>
          <video width="1000" height="600" autoplay controls>
            <!-- <source src="@/assets/sp.mp4" type="video/mp4" /> -->
          </video>
        </div>
      </div>
    </div>

    <section id="products" class="products" aria-labelledby="products-title">
      <div class="container">
        <div class="section-header">
          <h2 class="heading">产品功能</h2>
        </div>
        <div class="product-grid" role="list">
          <div class="product-card" role="listitem">
            <div class="icon" aria-hidden="true"><i class="bi bi-browser-chrome"></i></div>
            <h3>浏览器自动化</h3>
            <p>免安装浏览器插件即可使用，支持同时控制多个浏览器</p>
          </div>
          <div class="product-card">
            <div class="icon"><i class="bi bi-window"></i></div>
            <h3>Windows软件自动化</h3>
            <p>支持Windows软件自动化操作，灵活操作ERP、OA等软件</p>
          </div>
          <div class="product-card">
            <div class="icon"><i class="bi bi-table"></i></div>
            <h3>EXCEL自动化</h3>
            <p>自动处理Excel数据，简化表格操作流程</p>
          </div>
          <div class="product-card">
            <div class="icon"><i class="bi bi-window-stack"></i></div>
            <h3>应用多开运行</h3>
            <p>支持应用多开同时运行，提高工作处理效率</p>
          </div>


        </div>
      </div>
    </section>

    <section id="features" class="features">
      <div class="container">
        <div class="section-header">
          <h2 class="heading">核心特性</h2>
        </div>
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-icon"><i class="bi bi-wifi-off"></i></div>
            <div class="feature-content">
              <h3>支持离线使用</h3>
              <p>无需联网登录，在离线环境下也能自由使用</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon"><i class="bi bi-box-seam"></i></div>
            <div class="feature-content">
              <h3>应用打包EXE</h3>
              <p>支持应用打包为可执行文件，轻松分享和使用</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon"><i class="bi bi-window"></i></div>
            <div class="feature-content">
              <h3>自定义设计软件界面</h3>
              <p>打造属于自己个性化的软件界面</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon"><i class="bi bi-key"></i></div>
            <div class="feature-content">
              <h3>权限授权控制</h3>
              <p>打包的EXE支持权限授权，更好地控制使用权限</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon"><i class="bi bi-lock"></i></div>
            <div class="feature-content">
              <h3>应用加密分享</h3>
              <p>支持应用加密分享，保护您的流程设计</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon"><i class="bi bi-camera"></i></div>
            <div class="feature-content">
              <h3>支持OCR识别</h3>
              <p>识别图片内容、识别验证码，自动处理图像信息</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Tutorials Section -->
    <div class="section" id="news">
      <div class="section-container">
        <h2 class="heading">使用教程</h2>

        <div class="news__items">
          <div class="news__item wow fadeIn" v-for="(tutorial, index) in tutorials" :key="index"
            @click="routerToPage(tutorial.href)">
            <div class="news-item__title">
              <div :class="{ 'highlight': tutorial.highlight }">{{ tutorial.title }}</div>
            </div>
            <div class="news-item__summary">
              {{ tutorial.summary }}
            </div>
          </div>
        </div>

        <div class="more">
          <router-link to="/help" class="more-btn wow fadeInUp">
            <span>查看更多</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"
              class="more-icon">
              <path fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
            </svg>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Pricing Section -->
    <div class="section" id="money">
      <div class="section-container">
        <h2 class="heading">价格方案</h2>

        <div class="pricing-cards">
          <div class="pricing-card wow fadeIn">
            <h3 class="pricing-title">免费试用</h3>
            <div class="pricing-price">¥0</div>
            <ul class="pricing-features">
              <li>7天免费体验</li>
              <li>完整功能试用</li>
              <li>基础技术支持</li>
            </ul>
            <a href="http://jsautotask.com/resource-download" target="_blank" class="pricing-button">立即下载</a>
          </div>

          <div class="pricing-card wow fadeIn">
            <h3 class="pricing-title">月卡会员</h3>
            <div class="pricing-price">¥12</div>
            <ul class="pricing-features">
              <li>30天完整使用</li>
              <li>优先技术支持</li>
              <li>定期功能更新</li>
            </ul>
            <a href="https://item.taobao.com/item.htm?ft=t&id=728519283861" target="_blank"
              class="pricing-button">购买月卡</a>
          </div>

          <div class="pricing-card wow fadeIn highlight">
            <h3 class="pricing-title">年卡会员</h3>
            <div class="pricing-price">¥99</div>
            <div class="pricing-save">节省 ¥45</div>
            <ul class="pricing-features">
              <li>365天完整使用</li>
              <li>VIP技术支持</li>
              <li>所有功能更新</li>
              <li>专属客服通道</li>
            </ul>
            <a href="https://h5.m.taobao.com/awp/core/detail.htm?ft=t&id=741081932023" target="_blank"
              class="pricing-button">购买年卡</a>
          </div>
        </div>

        <div class="faq">
          <div class="faq__item wow fadeIn" v-for="(item, index) in faqItems" :key="index" @click="toggleFAQ(index)"
            :class="{ active: activeFAQ === index }">
            <div class="question">
              <h3>{{ item.question }}</h3>
            </div>
            <div class="answer">
              <div class="answer-content" v-html="item.answer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer>
      <div class="footer-container">
        <p>&copy; 2022-2023 jsautotask.com. All Rights Reserved.</p>
        <p><a href="http://beian.miit.gov.cn">鲁ICP备2023020479号-1</a> 有任何问题或意见欢迎与我们联系：<a
            href="mailto:jsautotask@163.com">jsautotask@163.com</a></p>
      </div>
    </footer>

    <!-- AI助手悬浮框 -->
    <div v-if="isShowAI">
      <AiBot />
    </div>
  </div>
</template>

<script>
import { inject } from 'vue'
import { ElButton } from 'element-plus'
import Swiper, { Autoplay } from 'swiper'
import 'swiper/css/autoplay'  // 引入 Autoplay 样式（Swiper 6+ 可能需要）
import 'swiper/css'
import { useRouter } from "vue-router"
import AiBot from '@/views/front/AiBot.vue'
import downloadApi from '@/api/download'

export default {
  components: {
    ElButton,
    AiBot
  },
  name: 'FrontLayout',
  setup() {
    const jQuery = inject('jQuery')
    const router = useRouter()  // 在 setup 内部调用

    return { jQuery, router }
  },
  data() {
    return {
      isScrolled: false,
      shipinVisible: false,
      activeFAQ: null,
      navOpen: false,
      heroImages: [
        'http://jsautotask.com/imgs/项目管理.png',
        'http://jsautotask.com/imgs/脚本编辑界面.png'
      ],
      showEnlargedImage: false,
      currentEnlargedImage: '',
      isShowAI: false,
      faqItems: [
        {
          question: "1. 键鼠自动化的开发目的是什么",
          answer: "键鼠自动化致力于解放双手，打造一款人人都能轻松使用、价格亲民的工具，为大家带来便捷的体验。"
        },
        {
          question: "2. 是否提供定制价格方案？",
          answer: "键鼠自动化不提供定制软件，致力于开发出满足市场90%以上的需求，仅提供代写服务。"
        },
        {
          question: "3. 代写如何收费？",
          answer: "键鼠自动软件，为用户免费提供设计思路。但对于需要付费代写用户，我们提供低价代写，并教会您基本使用方式，详细价格售后群咨询。"
        }
      ],
      tutorials: [
        {
          title: "软件介绍",
          href: "软件介绍",
          summary: "欢迎来到键鼠自动化的世界！在这个快节奏的时代，时间对我们来说变得越来越宝贵。无论是日常办公、游戏竞技还是重复性的任务，我们都能帮您以更高效、智能的方式完成任务。"
        },
        {
          title: "基础使用介绍(必看)",
          href: "界面功能介绍",
          highlight: true,
          summary: "软件的基础使用介绍，让您快速进入自动化的世界，更丰富的软件功能，更多的快捷设置，更快速的创建脚本，让您拿捏游戏，拿捏办公，解放您的双手，快点击进入学习使用。"
        },
        {
          title: "鼠标任务介绍",
          href: "鼠标点击",
          summary: "支持鼠标任意类型的点击操作，支持任意随机延迟，支持各种坐标获取方式，更精准，更快速的鼠标点击，每秒上万次的操作，解放您的双手，快点击进入学习使用。"
        },
        {
          title: "键盘任务介绍",
          href: "模拟按键",
          summary: "无论是单个按键还是组合键，都可以轻松模拟。您可以编写自定义脚本，让软件按照您的指令自动完成特定的键盘操作。无论是快捷键、功能键还是特殊符号键，都能被准确地模拟。除了自动按键，该软件还支持自动输入文本。"
        },
        {
          title: "找图任务介绍",
          href: "图像查找",
          summary: "图像查找功能，能够极大地简化您的工作流程。它支持自定义选取查找区域，您可以精确指定需要搜索的图像区域，从而提高查找的准确性和效率。此外，软件还允许您自定义设置识别度和缩小率，以适应不同的图像特征和分辨率。"
        },
        {
          title: "找字任务介绍",
          href: "文字查找",
          summary: "强大的文字查找功能，直接选择区域获取文字信息。内置了免费的OCR文字识别功能，轻松地将图片中的文字转化为可编辑的文本。软件还支持在线云识别。同时，提供了逻辑判断和调试功能，实时调试，确保准确无误。"
        }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.setupNavLinks()

    // Initialize Bootstrap JS
    this.jQuery('.collapse').collapse()

    new Swiper('.swiper-container', {
      modules: [Autoplay],
      loop: true,
      preventClicks: false,
      preventClicksPropagation: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    })
    setTimeout(()=>{
        this.isShowAI = true;
    },500)
    
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    goToResourceDownload() {
      this.$router.push('/resource-download');
    },
    async openDownloadLink() {
      try {
        const response = await downloadApi.getDownloadLink()
        if (response && response.link) {
          window.open(response.link, '_blank');
        } else {
          console.error('下载链接获取失败:', response);
          // 备用链接，确保在API失败时仍能下载
          window.open('http://39.96.179.106:60000/jsautotask-moduledata/install/JSAutoTask_3.0.6.exe', '_blank');
        }
      } catch (error) {
        console.error('获取下载链接时出错:', error);
        // 异常情况下使用备用链接
        window.open('http://39.96.179.106:60000/jsautotask-moduledata/install/JSAutoTask_3.0.6.exe', '_blank');
      }
    },
    toggleFAQ(index) {
      this.activeFAQ = this.activeFAQ === index ? null : index
    },
    toggleNav() {
      this.navOpen = !this.navOpen
      if (this.navOpen) {
        document.addEventListener('click', this.handleClickOutside)
      } else {
        document.removeEventListener('click', this.handleClickOutside)
      }
    },
    handleClickOutside(event) {
      const navbarLinks = document.getElementById("navbarLinks")
      const navbarToggler = document.querySelector(".navbar-toggler")

      if (navbarLinks && navbarToggler &&
        !navbarLinks.contains(event.target) &&
        !navbarToggler.contains(event.target)) {
        this.navOpen = false
        document.removeEventListener('click', this.handleClickOutside)
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10
    },
    routerToPage(url) {

      this.router.push(`/help/${url}`)
    },
    setupNavLinks() {
      const navbarLinks = document.getElementById("navbarLinks")?.querySelectorAll("a")
      if (navbarLinks) {
        // Set initial active link based on hash
        this.updateActiveLink()

        // Update active link on scroll
        window.addEventListener('scroll', this.updateActiveLink)

        navbarLinks.forEach(link => {
          link.addEventListener("click", (event) => {
            // Close the navigation menu when any link is clicked
            this.navOpen = false
            document.removeEventListener('click', this.handleClickOutside)
            
            const targetId = link.getAttribute("data-target")
            if (!targetId) return

            event.preventDefault()
            const targetElement = document.getElementById(targetId)
            if (targetElement) {
              const navbarHeight = document.querySelector('.navbar').offsetHeight
              const targetPosition = targetElement.offsetTop - navbarHeight + 20
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth"
              })

              // Update URL hash without triggering scroll
              history.pushState(null, null, `#${targetId}`)
              this.updateActiveLink()
            }
          })
        })
      }
    },
    updateActiveLink() {
      const navbarLinks = document.getElementById("navbarLinks")?.querySelectorAll("a")
      if (!navbarLinks) return

      // Get current scroll position
      const scrollPosition = window.scrollY + document.querySelector('.navbar').offsetHeight

      // Find which section is in view
      let activeLink = null
      navbarLinks.forEach(link => {
        const targetId = link.getAttribute("data-target")
        if (!targetId) return

        const targetElement = document.getElementById(targetId)
        if (targetElement) {
          const targetTop = targetElement.offsetTop
          const targetBottom = targetTop + targetElement.offsetHeight

          if (scrollPosition >= targetTop && scrollPosition < targetBottom) {
            activeLink = link
          }
        }
      })

      // Update active class
      navbarLinks.forEach(link => {
        link.parentElement.classList.toggle('active', link === activeLink)
      })
    },
    shipinClose() {
      this.shipinVisible = false
    },
    handleSwiperClick(event) {
      // 检查点击的是否是图片元素
      const imgElement = event.target.closest('.swiper-image');
      if (imgElement) {
        this.enlargeImage(imgElement.dataset.src);
      }
    },
    enlargeImage(image) {
      console.log(image);

      this.currentEnlargedImage = image;
      this.showEnlargedImage = true;

    },
    closeEnlargedImage() {
      this.showEnlargedImage = false;
      this.currentEnlargedImage = null
    },

  }
}
</script>

<style scoped>
.front-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #2d3748;
  line-height: 1.6;
  overflow-x: hidden;
  width: 100%;
}

/* Navbar styles */
.navbar {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.navbar.scrolled {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.navbar-nav li {
  margin: 0 0.75rem;
}

.navbar-nav a {
  color: #4a5568;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
  position: relative;
}

.navbar-nav a:hover {
  color: #4299e1;
}

.navbar-nav a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 1rem;
  right: 1rem;
  height: 2px;
  background-color: #4299e1;
  transform: scaleX(0);
  transition: transform 0.2s ease;
}

.navbar-nav a:hover::after {
  transform: scaleX(1);
}

.navbar-nav li.active a {
  color: #4299e1;
}

.navbar-nav li.active a::after {
  transform: scaleX(1);
}

/* Hero section */
.hero {
  background-image: linear-gradient(120deg, #f8f9fa 0%, #e9effd 100%);
  position: relative;
  overflow: hidden;
  margin-top: 70px;
  height: 500px;
  display: flex;
  align-items: center;
}

.hero::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle, rgba(66, 153, 225, 0.1) 0%, rgba(0, 0, 0, 0) 70%);
  animation: pulse 15s infinite alternate;
}

@keyframes pulse {
  0% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(50px, 50px);
  }

  100% {
    transform: translate(0, 0);
  }
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 50px auto 0;
  width: 100%;
  height: 100%;

}

.hero-animation {
  overflow: hidden;
  height: 100%;
}

.hero-content {
  flex: 0 0 50%; /* 内容区域占40% */
  text-align: left;
  padding-right: 3rem;
  z-index: 2;
}

.hero-animation {
  flex: 0 0 70%; /* 图片区域占55% */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.hero-animation img {
  max-height: 90%;
  max-width: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.hero-title {
  font-size: 2.5rem; /* 稍微减小字号 */
  font-weight: 800;
  margin-bottom: 1.2rem;
  line-height: 1.2;
  color: #2d3748;
}

.hero-subtitle {
  font-size: 1.15rem; /* 稍微减小字号 */
  color: #4a5568;
  margin-bottom: 2rem;
  max-width: 500px;
}

/* Sections */
.section {
  padding: 6rem 0;
  position: relative;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.heading {
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 3rem;
  text-align: center;
  color: #2d3748;
  position: relative;
  display: block;
  width: 100%;
}

.heading::after {
  content: '';
  position: absolute;
  bottom: -0.75rem;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 3px;
  background-color: #4299e1;
}

/* Product Features */
.products {
  /* background: #f8fafc; */
  padding: 6rem 0;
  max-width: 1200px;
  margin: 0 auto;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-top: 3rem;

}

.product-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  text-align: center;
  border: 1px solid rgba(66, 153, 225, 0.1);
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  border-color: rgba(66, 153, 225, 0.3);
}

.product-card .icon {
  font-size: 2.5rem;
  color: #4299e1;
  margin-bottom: 1.5rem;
}

.product-card h3 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #2d3748;
}

.product-card p {
  color: #718096;
  line-height: 1.6;
}

/* Core Features */
.features {
  padding: 6rem 0;
  background: #fff;
  max-width: 1200px;
  margin: 0 auto;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.feature-item {
  display: flex;
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid rgba(66, 153, 225, 0.1);
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  border-color: rgba(66, 153, 225, 0.3);
}

.feature-icon {
  font-size: 2rem;
  color: #4299e1;
  margin-right: 1.5rem;
  flex-shrink: 0;
}

.feature-content h3 {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  color: #2d3748;
}

.feature-content p {
  color: #718096;
  line-height: 1.6;
}

.features-item__body {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.features-item-body__title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  color: #2d3748;
}

.features-item-body__summary {
  color: #718096;
  line-height: 1.6;
}

.features__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Tutorials Section */
#news {
  background: #f8fafc;
  padding: 6rem 0;
}

.news__items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.news__item {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid rgba(66, 153, 225, 0.1);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.news__item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  border-color: rgba(66, 153, 225, 0.3);
}

.news__item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #4299e1, #38b2ac);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.news__item:hover::after {
  transform: scaleX(1);
}

.news-item__title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #2d3748;
  position: relative;
  padding-bottom: 0.5rem;
}

.news-item__title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: #4299e1;
}

.news-item__title a {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;
}

.news-item__title a:hover {
  color: #4299e1;
}

.news-item__title.highlight a {
  color: #4299e1;
  font-weight: 600;
}

.news-item__summary {
  color: #718096;
  line-height: 1.6;
  margin-top: 1rem;
}

/* Pricing Cards */
.pricing-cards {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin: 3rem auto;
  flex-wrap: wrap;
}

.pricing-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  width: 280px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.pricing-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.pricing-card.highlight {
  border: 2px solid #4299e1;
  position: relative;
}

.pricing-card.highlight::before {
  content: '推荐';
  position: absolute;
  top: -10px;
  right: 20px;
  background: #4299e1;
  color: white;
  padding: 0.25rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
}

.pricing-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1rem;
  text-align: center;
}

.pricing-price {
  font-size: 2rem;
  font-weight: 700;
  color: #4299e1;
  text-align: center;
  margin-bottom: 1.5rem;
}

.pricing-save {
  color: #38a169;
  font-weight: 500;
  text-align: center;
  margin-bottom: 1rem;
}

.pricing-features {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
}

.pricing-features li {
  padding: 0.5rem 0;
  color: #4a5568;
  position: relative;
  padding-left: 1.5rem;
}

.pricing-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #4299e1;
  font-weight: bold;
}

.pricing-button {
  display: block;
  text-align: center;
  background: #4299e1;
  color: white;
  padding: 0.75rem;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
nsition: all 0.2s ease;
}

.faq__item:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.swiper-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

.question {
  padding: 1.5rem;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.question h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #2d3748;
  font-weight: 600;
}

.question::after {
  content: '+';
  font-size: 1.5rem;
  color: #4299e1;
  transition: transform 0.3s ease;
}

.faq__item.active .question::after {
  content: '-';
}

.answer {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  background: #f8fafc;
  opacity: 0;
  transform: translateY(-10px);
}

.faq__item.active .answer {
  max-height: 500px;
  opacity: 1;
  transform: translateY(0);
}

.answer-content {
  padding: 0 1.5rem 1.5rem;
  color: #4a5568;
  line-height: 1.6;
}

.answer a {
  color: #4299e1;
  text-decoration: none;
  font-weight: 500;
}

.swiper-container {
  position: relative;
}

.swiper-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

/* 确保图片可点击 */
.swiper-slide {
  pointer-events: auto;
}

.swiper-image {
  cursor: pointer;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.answer a:hover {
  text-decoration: underline;
}

/* Footer */
footer {
  background: #2d3748;
  color: #fff;
  padding: 3rem 0;
  font-size: 0.9rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

footer a {
  color: #a0aec0;
  text-decoration: none;
  transition: color 0.2s ease;
}

footer a:hover {
  color: #fff;
}
@media (max-width: 1500px) {
  
  .hero {
    height: auto;
    padding: 3rem 0 4rem;
  }
  .hero {
    padding: 4rem 0 2rem;
    margin-top: 17px;
  }

  .hero-container {
    flex-direction: column-reverse;
    text-align: center;
  }

  .hero-content {
    flex: 0 0 100%;
    padding: 0 14px;
    margin-bottom: 3rem;
    text-align: center;
    margin-top: 23px;
  }

  .hero-animation {
    flex: 0 0 100%;
    max-width: 90%;
    height: 300px;
  }

  .hero-title {
    font-size: 2rem;
    letter-spacing: 7px;
  }

  .hero-subtitle {
    margin-left: auto;
    margin-right: auto;
  }
}
/* Responsive adjustments */
@media (max-width: 768px) {

  html,
  body {
    width: 100%;
    overflow-x: hidden;
    position: relative;
  }


  .navbar-brand {
    width: 100%;
    text-align: center;
    padding: 0.5rem 0;
  }

  .section-container {
    padding: 0;
  }

  .navbar-nav {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .navbar-nav li {
    margin: 0;
  }

  .navbar-nav a {
    display: block;
    padding: 0.5rem 1rem;
    text-decoration: none;
    color: #2d3748;
    transition: color 0.2s ease;
  }

  .navbar-nav a:hover {
    color: #4299e1;
  }

  .navbar-nav li.active a {
    color: #4299e1;
    font-weight: 600;
  }



  .section {
    padding: 3rem 0;
  }

  .heading {
    font-size: 1.75rem;
  }

  /* Product grid mobile */
  .product-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  /* Features grid mobile */
  .features-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  /* Adjust card padding on mobile */
  .product-card,
  .feature-item {
    padding: 1.5rem;
  }

  /* Tutorial items mobile */
  .news__items {
    grid-template-columns: 1fr;
  }

  /* Pricing cards mobile */
  .pricing-cards {
    flex-direction: column;
    align-items: center;
  }

  .pricing-card {
    width: 100%;
    max-width: 300px;
    margin-bottom: 1.5rem;
  }

}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.wow {
  animation: fadeIn 0.6s ease forwards;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.more {
  text-align: center;
  margin: 20px 0;
}

.more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: #4285f4;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.more-btn:hover {
  background-color: #3367d6;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.more-icon {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.more-btn:hover .more-icon {
  transform: translateX(3px);
}

.navbar-brand {
  height: 50px;
}

.navbar-toggler {
  display: none;
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #2d3748;
  font-weight: 500;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

/* 添加新的断点，确保导航栏不会显示两行 */
@media (max-width: 1200px) {
  .navbar-nav {
    display: none;
  }
  
  .navbar-nav.show {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding: 0.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 999;
    border-radius: 0;
    border: none;
  }
  
  .navbar-nav.show li {
    margin: 0;
  }
  
  .navbar-nav.show a {
    display: block;
    padding: 0.5rem 1rem;
    border-radius: 0;
    text-decoration: none;
    color: #2d3748;
    transition: all 0.2s ease;
    font-size: 0.9rem;
  }
  
  .navbar-nav.show a:hover {
    background-color: transparent;
    color: #4299e1;
    transform: none;
    border-bottom-color: rgba(66, 153, 225, 0.3);
  }
  
  .navbar-nav.show li.active a {
    background-color: transparent;
    color: #4299e1;
    font-weight: 600;
    border-bottom-color: #4299e1;
  }
  
  .navbar-toggler {
    display: flex;
    position: absolute;
    right: 1rem;
    top: 25px;
  }
}

/* 在大屏幕上隐藏菜单按钮 */
@media (min-width: 1201px) {
  .navbar-toggler {
    display: none !important;
  }
  
  .navbar-nav {
    display: flex !important;
  }
}

.download-btn {
  width: 133px;
  height: 48px;
  border-radius: 23px;
}

/* AI助手悬浮框样式 */
.webchat-container {
  z-index: 100;
  bottom: 10px;
  right: 10px;
}

.webchat-bubble-tip {
  z-index: 99;
  bottom: 20px;
  right: 20px;
}

.image-enlarger {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.image-enlarger-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.image-enlarger-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.image-enlarger img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}
</style>
